import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  MessageCircle,
  MessageSquare,
  Plug,
  Users,
  UsersRound,
} from 'lucide-react';

const NAV_ITEMS = [
  { label: 'Ask STASH', to: '/app/chat', icon: MessageSquare },
  { label: 'Friends', to: '/app/friends', icon: Users },
  { label: 'STASH Board', to: '/app/stashboard', icon: LayoutDashboard },
  { label: 'Groups', to: '/app/groups', icon: UsersRound },
  { label: 'Messages', to: '/app/messages', icon: MessageCircle },
  { label: 'Connected Apps', to: '/app/connected-apps', icon: Plug },
] as const;

export function AppSidebarMobileBar(): React.JSX.Element {
  return (
    <nav
      aria-label="Primary (mobile)"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 md:hidden z-30"
    >
      <div className="flex items-center gap-1 rounded-full border border-border bg-background/80 px-3 py-2 backdrop-blur shadow-lg">
        {NAV_ITEMS.map(({ label, to, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            aria-label={label}
            className={({ isActive }) =>
              `flex h-10 w-10 items-center justify-center rounded-full transition-colors ${
                isActive
                  ? 'text-[var(--stash-blue-dark)]'
                  : 'text-muted-foreground hover:text-foreground'
              }`
            }
          >
            <Icon size={20} />
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
